<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { globalTechnologieWaermeerzeugungCollection } from '@/models/TechnologieWaermeerzeugung';
import type { Ref } from 'vue';

const value: Ref<any> = defineModel();

defineProps<{
    label?: string;
}>();

const technos = globalTechnologieWaermeerzeugungCollection();
</script>
<template>
    <KpSelectField
        :label="label"
        v-model="value"
        :options="technos.getModels()"
        :option-label="(v: any) => $t(v.i18n_key) + ' (' + v.code + ')'"
        option-value="id"
    ></KpSelectField>
</template>
